'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.captureEvent = exports.getSentryConfig = exports.initMonitoring = exports.createMonitoringMiddleware = exports.captureException = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = require('lodash.get');

var _lodash2 = _interopRequireDefault(_lodash);

var _libEnvironment = require('@doordash/lib-environment');

var _browser = require('@sentry/browser');

var Sentry = _interopRequireWildcard(_browser);

var _ignoreConfig = require('./ignoreConfig');

var _ignoreConfig2 = _interopRequireDefault(_ignoreConfig);

var _reduxSentryMiddleware = require('redux-sentry-middleware');

var _reduxSentryMiddleware2 = _interopRequireDefault(_reduxSentryMiddleware);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Call this function to capture an exception manually. By default all 
 * uncaught JS exceptions will be reported automatically, but in some cases
 * it might be helpul to report errors manually. For instance, if you wanted
 * to capture all API errors with a 500 status, you could call this function
 * in an axios interceptor whenever a 500 error occurs.
 * 
 * It’s also possible to throw strings as errors (in which 
 * case no traceback can be recorded). 
 * 
 * ```js
 * import { captureException } from '@doordash/lib-monitoring'
 * 
 * try {
 *  aFunctionThatMightFail();
 * } catch (err) {
 *    captureException(err);
 * }
 */
var captureException = function captureException(exception) {
  Sentry.captureException(exception);
};

/**
 * Call this function to capture an event manually. 
 * 
 * ```js
 * import { captureEvent } from '@doordash/lib-monitoring'
 * 
 * captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * })
 */
var captureEvent = function captureEvent(event) {
  Sentry.captureEvent(event);
};

var getSentryConfig = function getSentryConfig(customConfigSentry) {
  var defaultConfigSentry = _extends({}, _ignoreConfig2.default, {
    release: (0, _lodash2.default)(window, '__dd.sha', 'development'),
    environment: (0, _libEnvironment.getDSJEnvironment)()
  });

  return _extends({}, defaultConfigSentry, customConfigSentry);
};

/**
 * [initMonitoring description]
 * Function that sets up Sentry for your application. You can
 * override any setting, but you'll need to provide the DSN of the
 * application, which is the identifier Sentry uses to send the errors
 * to the correct dashboard
 *
 * @param  {object} customConfigSentry - any sentry config override
 */
var initMonitoring = function initMonitoring(customConfigSentry) {
  var sentryConfig = getSentryConfig(customConfigSentry);

  Sentry.init(sentryConfig);
};

/**
 * [createMonitorMiddleware description]
 * Function to setup a Sentry middleware for your Redux application.
 * This will allow monitoring events to include the state of your
 * application, as well as the last action called before the error
 * happened.
 * 
 * @return {object} returns Redux middleware to use with applyMiddleware
 */
var createMonitoringMiddleware = function createMonitoringMiddleware() {
  return (0, _reduxSentryMiddleware2.default)(Sentry);
};

exports.captureException = captureException;
exports.createMonitoringMiddleware = createMonitoringMiddleware;
exports.initMonitoring = initMonitoring;
exports.getSentryConfig = getSentryConfig;
exports.captureEvent = captureEvent;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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